/**
 * @file Form Controller
 */

'use strict';
import Common from '../util/_common';
import Listener from '../util/_listener';
import ApplyClass from '../util/_apply-class';
import FormValidateView from '../view/_form-validate-view';
import FormModel from '../model/_form-model';


let instance = null;

/**
 * @classname Form
 * @classdesc Form Controller
 */
export default class Form {

	/**
	 * @constructor
	 */
	constructor() {
		if (instance) {
			return instance;
		}
		console.log('Form.constructor');
		this._listener = new Listener();
		this._model = new FormModel();
		this._$form = null;
		this._submit = true;
		this._numberingNo = 1;

		this._model.on('onGetAvailableDateComplete', () => {
			this._data = this._model._data;
			this._listener.trigger('onGetAvailableDateComplete');
		})

		instance = this;
		return instance;
	};

	/**
	 * 前処理終了
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	completePreProcessing($form) {
		console.log('Form.completePreProcessing');
		this._$form = $form;
		this._listener.trigger('completePreProcessing');
	};


	/**
	 * バリデーションチェック
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	validate($form) {
		console.log('Form.validate');
		this._$form = $form;
		this._listener.trigger('validate');
		setTimeout(() => {
			this._listener.trigger('completeValidate');
		}, 500);
	};


	/**
	 * 後処理終了
	 *
	 * @memberof Form
	 * @param {jQuery} $form - フォームオブジェクト
	 * @return {undefined}
	 */
	completePostProcessing($form) {
		console.log('Form.completePostProcessing');
		this._$form = $form;
		this._listener.trigger('completePostProcessing');
	};


	/**
	 * サブミットボタン初期化
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	initialize() {
		console.log('Form.initialize');
		this._listener.trigger('initialize');
	};


	/**
	 * コールバック待ち初期化
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	waitCallback() {
		console.log('Form.waitCallback');
		this._listener.trigger('waitCallback');
	};


	/**
	 * 商品画像ブロックアクティベート
	 *
	 * @memberof Form
	 * @param {int} imageNo - 商品画像番号
	 * @return {undefined}
	 */
	activateProductImageBlock(imageNo) {
		console.log('Form.activateProductImageBlock');
		const $addFileImage = $(`[data-file-image-no=${imageNo}] .add-file-image`);
		const $deleteFileImage = $(`[data-file-image-no=${imageNo}] .delete-file-image`);
		const $dropArea = $(`[data-file-image-no=${imageNo}] .drop-area`);
		const $inputFileSelect = $(`[data-file-image-no=${imageNo}] input.input-file-select[type=file]`);
		const $validate = $(`[data-file-image-no=${imageNo}] .validate`);
		ApplyClass.apply(FormAddFileImageView, $addFileImage, [this, $addFileImage]);
		ApplyClass.apply(FormDeleteFileImageView, $deleteFileImage, [this, $deleteFileImage]);
		ApplyClass.apply(FormFileDropView, $dropArea, [this, $dropArea]);
		ApplyClass.apply(FormFileSelectView, $inputFileSelect, [this, $inputFileSelect]);
		ApplyClass.apply(FormValidateView, $validate, [this, $validate]);
		this.reNumberingFileImage();
	};


	/**
	 * 商品画像並べ替え
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	reNumberingFileImage() {
		console.log('Form.reNumberingFileImage');
		let no = 1;
		$('[data-file-image-no]').each(function(idx, e){
			const $e = $(e);
			$e.attr('data-file-image-no', no).find('.file-image-no').text(no);
			$e.find('.image_url').attr('name', `image_url${no}`);
			no ++;
		});
	};


	/**
	 * SKUブロックアクティベート
	 *
	 * @memberof Form
	 * @param {int} skuNo - SKU番号
	 * @return {undefined}
	 */
	activateSkuBlock(skuNo) {
		console.log('Form.activateSkuBlock');
		const $addSku = $(`[data-sku-no=${skuNo}] .add-sku`);
		const $deleteSku = $(`[data-sku-no=${skuNo}] .delete-sku`);
		ApplyClass.apply(FormAddSkuView, $addSku, [this, $addSku]);
		ApplyClass.apply(FormDeleteSkuView, $deleteSku, [this, $deleteSku]);
		const controller = this;
		$(`[data-sku-no=${skuNo}] .validate`).each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FormValidateView, $e, [controller, $e]);
		});
		this.reNumberingSku();
		$('#sku_num').val(skuNo);
	};


	/**
	 * SKU並べ替え
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	reNumberingSku() {
		console.log('Form.reNumberingSku');
		let no = 1;
		$('.form-group-sku [data-sku-no]').each(function(idx, e){
			const $e = $(e);
			$e.attr('data-sku-no', no).find('.sku-no').text(no);
			$('#sku_num').val(no);
			no ++;
		});
	};


	/**
	 * オプションブロックアクティベート
	 *
	 * @memberof Form
	 * @param {int} optionNo - オプション番号
	 * @return {undefined}
	 */
	activateOptionBlock(optionNo) {
		console.log('Form.activateOptionBlock');
		const $addOption = $(`[data-option-no=${optionNo}] .add-option`);
		const $deleteOption = $(`[data-option-no=${optionNo}] .delete-option`);
		const $dropArea = $(`[data-option-no=${optionNo}] .drop-area`);
		const $inputFileSelect = $(`[data-option-no=${optionNo}] input.input-file-select[type=file]`);
		const controller = this;
		ApplyClass.apply(FormAddOptionView, $addOption, [this, $addOption]);
		ApplyClass.apply(FormDeleteOptionView, $deleteOption, [this, $deleteOption]);
		ApplyClass.apply(FormFileDropView, $dropArea, [this, $dropArea]);
		ApplyClass.apply(FormFileSelectView, $inputFileSelect, [this, $inputFileSelect]);
		$(`[data-option-no=${optionNo}] .validate`).each(function(idx, e){
			const $e = $(e);
			ApplyClass.apply(FormValidateView, $e, [controller, $e]);
		});
		this.reNumberingOption();
	};


	/**
	 * オプション並べ替え
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	reNumberingOption() {
		console.log('Form.reNumberingOption');
		let no = 1;
		$('[data-option-no]').each(function(idx, e){
			const $e = $(e);
			$e.attr('data-option-no', no).find('.option-no').text(no);
			$e.find('.option_image_url').attr('name', `option_image_url${no}`);
			no ++;
		});
	};


	/**
	 * ファイルinputリセット
	 *
	 * @memberof Form
	 * @return {undefined}
	 */
	resetFileInput() {
		console.log('Form.resetFileInput');
		this._listener.trigger('resetFileInput');
	};


	/**
	 * 受け取り可能日取得
	 *
	 * @memberof Form
	 * @param {string} shopId - 店舗ID
	 * @param {boolean} xmasFlg - クリスマスフラグ
	 * @return {undefined}
	 */
	getAvailableDate(shopId, xmasFlg) {
		console.log('Form.getAvailableDate');
		this._model.getAvailableDate(shopId, xmasFlg)
	};


	/**
	 * listener on
	 *
	 * @memberof Form
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	on(name, fn) {
		this._listener.on(name, fn);
	};


	/**
	 * listner off
	 *
	 * @memberof Form
	 * @param {string} name - イベント名
	 * @param {function} fn - 実行する関数
	 * @return {undefined}
	 */
	off(name, fn) {
		this._listener.off(name, fn);
	};
}
